// Upload Constants
export const UPLOAD_IMAGE_URL = 'UPLOAD_IMAGE_URL';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';
export const UPLOAD_IMAGE_DIMENSIONS = 'UPLOAD_IMAGE_DIMENSIONS';

// Crop Constants
export const CROP_LOADING = 'CROP_LOADING';
export const SET_CROP_ENDPOINT_CALLED = 'SET_CROP_ENDPOINT_CALLED';
export const SET_CROP_DATA = 'SET_AUTO_CROP_DATA';
export const SET_MD5_DATA = 'SET_AUTO_CROP_MD5_DATA';
export const SET_INITIAL_REGION_DATA = 'SET_INITIAL_REGION_DATA';
export const SET_IS_ANY_REGION_DELETED = 'SET_IS_ANY_REGION_DELETED';
export const SET_ANNOTATION_INDEX = 'SET_AUTO_CROP_ANNOTATION_INDEX';
export const CROP_ERROR = 'CROP_ERROR';
export const SET_SELECTED_CROP_REGION = 'SET_SELECTED_CROP_REGION';
export const CROP_DRAWING = 'CROP_DRAWING';
export const SET_CROP_AREA_SIZE = 'SET_CROP_AREA_SIZE';
export const SET_CROPPED_IMAGE_URL = 'SET_CROPPED_IMAGE_URL';
export const SET_VERTICAL_CROP_SELECTED = 'SET_VERTICAL_CROP_SELECTED';
export const SET_ROTATION_AMOUNT = 'SET_ROTATION_AMOUNT';
export const SET_ROTATION_MODE = 'SET_ROTATION_MODE';

// CropToolbar Constants
export const SHOW_NEXT_BUTTON_ENABLED_TOOLTIP = 'SHOW_NEXT_BUTTON_ENABLED_TOOLTIP';

// Result Constants
export const SET_RESULT_DATA = 'SET_RESULT_DATA';
export const SET_FONT_PREVIEW_INPUT_DATA = 'SET_FONT_PREVIEW_INPUT_DATA';
export const SET_FONT_PREVIEW_SLIDER_VALUE = 'SET_FONT_PREVIEW_SLIDER_VALUE';
export const RESULTS_ERROR = 'RESULTS_ERROR';
export const SET_RESULT_REQUEST_FLAG = 'SET_RESULT_REQUEST_FLAG';
export const SET_RESULTS_PAGE_NUMBER = 'SET_RESULTS_PAGE_NUMBER';

// AB Experiment constants
export const EXPERIMENT_DATA = 'EXPERIMENT_DATA';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js